$(document).ready(function(){
  var observer = new IntersectionObserver(
    function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.intersectionRatio > 0.0) {
          img = entry.target;
          if (!img.hasAttribute('src')) {
            img.setAttribute('src', img.dataset.src)
            delete img.dataset.src
          }
        }
      });
    },
    {}
  )

  for (let img of document.querySelectorAll('img[data-src]')) {
    observer.observe(img);
  }
})



// WEBPACK FOOTER //
// ./assets/js/lazyload.js